<template>
  <div class="training-support">
    <loading v-if="loading"></loading>
    <div class="m-container" v-else>
      <!-- page header -->
      <div class="training-header">
        <h1><span>Training</span> & Support</h1>
      </div>

      <!-- games -->
      <div class="row">
        <div class="col-12 col-sm-6 col-md-4" v-for="el in trainingDocs" :key="el.id">
          <div class="wro-card sm-padding-bottom">
            <div class="wro-card-content sm-padding-bottom">
              <div class="d-flex align-items-center">
                <h3>{{ el.title }}</h3>
              </div>

              <div class="text-center">
                <img :src="el.image" alt="">
                <p class="card-content" :class="{'p-border-bottom': el.hreaf}">
                  {{ el.description }}
                </p>

                <p class="watch-video" v-if="el.hreaf">
                  <a :href="el.hreaf" target="_blank">Click-Here</a>
                  <span>For more</span>
                </p>
              </div>

            </div>
            <div class="edit-button">
              <a :href="el.link">
                <img src="@/assets/img/go.png" alt="Edit">
                Game Page
              </a>
            </div>
          </div>
        </div>
      </div>

      <sponsors></sponsors>
      <!-- contact us -->
      <contact-us></contact-us>
    </div>
  </div>
</template>

<script>
import ContactUs from "@/components/home/ContactUs";
import Loading from "@/components/Loading/loading";
import Sponsors from "@/components/home/Sponsors";

export default {
  name: "TrainingSupport",
  components: {Sponsors, Loading, ContactUs },
  data() {
    return {
      loading: true,
      trainingDocs: []
    }
  },
  mounted() {
    this.$API.general.getTrainingDocs()
    .then(response => {
      this.loading = false;
      this.trainingDocs = response;
    })
  }
}
</script>

<style scoped>

</style>